"use client";

import { Button } from "@/components/ui/button";
import { AnimatedArrow } from "./animated-arrow";
import { cn } from "@/lib/utils/tw";

interface BookDemoButtonProps {
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}

export const BookDemoButton = ({
  className,
  onClick,
  children = "Book a Demo",
}: BookDemoButtonProps) => {
  return (
    <Button
      onClick={onClick}
      variant="default"
      className={cn("group", className)}
    >
      {children}
      <AnimatedArrow />
    </Button>
  );
};
